import { LoanUsageOption } from '@/api/apply-product/types';

/**
 * 根据资方代码对借款用途列表进行排序
 * 如果是70047资方，将租房装修项（code: 'FITUP'）排到第一位
 * @param capitalCode 资方代码，可以是单个资方代码或串行模式下用下划线拼接的多个资方代码
 * @param usageList 借款用途列表
 * @returns 排序后的新列表（不修改原数组）
 */
export const sortLoanUsageListByCapitalCode = (
  capitalCode: string | undefined,
  usageList: LoanUsageOption[],
): LoanUsageOption[] => {
  if (!capitalCode || !usageList || usageList.length === 0) {
    return usageList;
  }

  // 检查是否为70047资方 或者70047资方在首位 (多资方是x_y 下划线拼接的多个资方代码)
  const isCapital70047 = capitalCode === '70047' || (capitalCode.includes('_') && capitalCode.split('_')[0] === '70047');
  if (!isCapital70047) {
    return usageList;
  }

  // 创建新数组，避免修改原数组
  const sortedList = [...usageList];
  const fitupIndex = sortedList.findIndex((item) => item.code === 'FITUP');

  // 如果找到租房装修项且不在第一位，将其移到第一位
  if (fitupIndex > 0) {
    const fitupItem = sortedList.splice(fitupIndex, 1)[0];
    sortedList.unshift(fitupItem);
  }

  return sortedList;
};
